import {
    Users, GitBranch, MessagesSquare, Workflow, MapPin, BarChart3, ArrowUpRight,
} from "lucide-react";
import { Container, Reveal, SectionHeader } from "./common";

const features = [
    {
        icon: Users,
        title: "Lead Management",
        desc: "Capture, track and nurture leads from any source — website, campaigns, imports or field teams.",
        testid: "feature-card-lead-management",
    },
    {
        icon: GitBranch,
        title: "Sales Pipeline",
        desc: "Visualize every opportunity, forecast revenue and close more deals with a pipeline that stays current.",
        testid: "feature-card-sales-pipeline",
    },
    {
        icon: MessagesSquare,
        title: "Engage Customers",
        desc: "Email, WhatsApp and automated sequences that keep conversations moving toward a close.",
        testid: "feature-card-engage",
    },
    {
        icon: Workflow,
        title: "Automation",
        desc: "Automate assignments, follow-ups and repetitive busywork so your team can focus on selling.",
        testid: "feature-card-automation",
    },
    {
        icon: MapPin,
        title: "Field Sales",
        desc: "Manage field teams, plan visits and routes, track check-ins and measure on-ground performance.",
        testid: "feature-card-field-sales",
    },
    {
        icon: BarChart3,
        title: "Reports & Analytics",
        desc: "Powerful, decision-ready insights across leads, pipeline, team activity and revenue.",
        testid: "feature-card-reports",
    },
];

const FeatureGrid = () => (
    <section id="features" data-testid="features-grid-container" className="bg-white py-20 lg:py-28">
        <Container>
            <SectionHeader
                eyebrow="The Platform"
                title="Everything you need to run your entire sales process"
                sub="One connected workspace for your sales team."
            />
            <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
                {features.map((f, i) => (
                    <Reveal key={f.title} delay={(i % 3) * 0.08}>
                        <article
                            data-testid={f.testid}
                            className="group relative h-full overflow-hidden rounded-2xl border border-[#E5E7EB] bg-white p-7 shadow-sm transition-all duration-300 hover:-translate-y-1.5 hover:border-[#16A34A]/30 hover:shadow-xl hover:shadow-[#16A34A]/[0.07]"
                        >
                            <div className="pointer-events-none absolute -right-10 -top-10 h-28 w-28 rounded-full bg-[#F0FDF4] opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                            <span className="relative flex h-12 w-12 items-center justify-center rounded-xl border border-[#16A34A]/15 bg-[#F0FDF4] transition-colors duration-300 group-hover:bg-[#16A34A]">
                                <f.icon className="h-5 w-5 text-[#16A34A] transition-colors duration-300 group-hover:text-white" />
                            </span>
                            <h3 className="relative mt-5 font-display text-lg font-bold text-[#111827]">
                                {f.title}
                            </h3>
                            <p className="relative mt-2 text-[15px] leading-relaxed text-[#64748B]">
                                {f.desc}
                            </p>
                            <span className="relative mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#16A34A] opacity-0 transition-all duration-300 group-hover:opacity-100">
                                Learn more <ArrowUpRight className="h-3.5 w-3.5" />
                            </span>
                        </article>
                    </Reveal>
                ))}
            </div>
        </Container>
    </section>
);

export default FeatureGrid;
